import { YesObject } from '@yes.technology/react-toolkit'
import { useCallback } from 'react'
import { PatchObjectResponse } from 'shared/types/object.type'
import patchObject from 'yesObject/shared/api/patchObject'

type UseOnSaveObjectProps = {
  objectUuid: string
  objectclassUuid: string
  version?: string

  onSuccess: (response?: PatchObjectResponse) => void
  onError: (response?: PatchObjectResponse) => void
}

export default function useOnSaveObject({
  objectUuid,
  objectclassUuid,
  version,
  onSuccess,
  onError
}: UseOnSaveObjectProps) {
  return useCallback(
    async (values: Partial<YesObject>): Promise<PatchObjectResponse> => {
      const response: PatchObjectResponse = await patchObject({
        uuid: objectUuid,
        data: {
          ...values,
          uuid_Objectclass: objectclassUuid,
          version
        },
        showLoading: true
      }).catch((e) => ({
        success: false,
        message: e instanceof Error ? e.message : String(e),
        data: null
      }))

      if (response.success) {
        onSuccess(response)
      } else {
        onError(response)
      }

      return response
    },
    [objectUuid, objectclassUuid, onError, onSuccess, version]
  )
}
